<lib-panel-layout>
  <div class="flex w-full min-w-0 flex-col gap-3">
    <lib-checkbox
      class="min-w-0"
      [label]="'EDITOR.DESKEW.RESIZE_PROPORTIONALLY' | translate"
      [checked]="resizeProportionally"
      (changed)="onResizeProportionallyChanged($event)">
    </lib-checkbox>

    <lib-checkbox
      class="min-w-0"
      [label]="'EDITOR.DESKEW.TRANSPARENT_BACKGROUND' | translate"
      [checked]="useTransparentBackground"
      (changed)="onTransparentBackgroundChanged($event)">
    </lib-checkbox>

    <lib-color-picker
      class="min-w-0"
      [label]="'EDITOR.DESKEW.BACKGROUND_COLOR' | translate"
      [value]="backgroundColor"
      [transparent]="useTransparentBackground"
      [displayValue]="useTransparentBackground ? ('EDITOR.DESKEW.TRANSPARENT' | translate) : undefined"
      (changed)="onBackgroundColorChanged($event)">
    </lib-color-picker>
  </div>

  <lib-apply-panel panelActions class="w-full" (apply)="onApply()" (cancelRequested)="onCancel()"></lib-apply-panel>
</lib-panel-layout>
